import React, { useState, useRef } from "react";

function WebcamModal({ isOpen, onClose, onVideoRecorded }) {
    const [isRecording, setIsRecording] = useState(false);
    const videoRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            videoRef.current.srcObject = stream;

            const mediaRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
            mediaRecorderRef.current = mediaRecorder;
            recordedChunksRef.current = [];

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    recordedChunksRef.current.push(event.data);
                }
            };

            mediaRecorder.onstop = () => {
                const blob = new Blob(recordedChunksRef.current, { type: "video/mp4" });
                const url = URL.createObjectURL(blob);
                onVideoRecorded(url);
                stream.getTracks().forEach((track) => track.stop()); // Stop the camera
                onClose();
            };

            mediaRecorder.start();
            setIsRecording(true);

            setTimeout(() => {
                mediaRecorder.stop();
                setIsRecording(false);
            }, 5000);
        } catch (error) {
            console.error("Error accessing the camera:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50">
            <div className="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-lg tw-w-96">
                <h2 className="tw-text-xl tw-font-bold tw-mb-4">Webcam Recording</h2>

                <div className="tw-text-center">
                    <video ref={videoRef} autoPlay muted className="tw-w-full tw-h-64 tw-rounded-lg"></video>
                    <button onClick={startRecording} className="tw-w-full tw-mt-4 tw-py-2 tw-bg-red-500 tw-text-white tw-rounded-md">
                        {isRecording ? "Recording..." : "Start Recording"}
                    </button>
                </div>

                <button onClick={onClose} className="tw-w-full tw-mt-4 tw-py-2 tw-bg-gray-300 tw-rounded-md">
                    Close
                </button>
            </div>
        </div>
    );
}

export default WebcamModal;
